import {connect} from "react-redux";
import PjpApprovedList from "./List";
import {bindActionCreators} from "redux";
import {pjpPending, getAM} from "../../../../service/FasttagToll/action";
const mapStateToProps = (state) => ({
    PJPPendingList:state.FasttagToll.PJPPendingList,
    allAm:state.FasttagToll.allAm
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            pjpPending,
            getAM
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PjpApprovedList);
